(() => {
  const money = (cents, format) => {
    const value = (Number(cents || 0) / 100).toLocaleString(undefined, {
      style: 'currency',
      currency: format || window.Shopify?.currency?.active || 'USD'
    });
    return value;
  };

  const menuButton = document.querySelector('.menu-toggle');
  const menu = document.querySelector('.main-nav');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
  }

  document.querySelectorAll('[data-countdown-hours]').forEach((bar) => {
    const key = 'budss-countdown-end';
    const hours = Number(bar.dataset.countdownHours || 16);
    let end = Number(sessionStorage.getItem(key));
    if (!end || end < Date.now()) {
      end = Date.now() + hours * 60 * 60 * 1000;
      sessionStorage.setItem(key, String(end));
    }
    const render = () => {
      const distance = Math.max(0, end - Date.now());
      const h = Math.floor(distance / 3600000);
      const m = Math.floor((distance % 3600000) / 60000);
      const s = Math.floor((distance % 60000) / 1000);
      bar.querySelector('[data-hours]').textContent = String(h).padStart(2, '0');
      bar.querySelector('[data-minutes]').textContent = String(m).padStart(2, '0');
      bar.querySelector('[data-seconds]').textContent = String(s).padStart(2, '0');
    };
    render();
    setInterval(render, 1000);
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const thumbs = [...section.querySelectorAll('[data-media-target]')];
    const media = [...section.querySelectorAll('[data-media-id]')];
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((item) => item.classList.remove('is-active'));
        media.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
        section.querySelector(`[data-media-id="${thumb.dataset.mediaTarget}"]`)?.classList.add('is-active');
      });
    });

    const form = section.querySelector('[data-product-form]');
    if (!form) return;
    const productJson = document.querySelector('[data-product-json]');
    const variants = productJson ? JSON.parse(productJson.textContent) : [];
    const optionSelects = [...form.querySelectorAll('[data-option-index]')];
    const idInput = form.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const comparePrice = section.querySelector('[data-compare-price]');
    const addButton = form.querySelector('[data-add-button]');
    const addLabel = form.querySelector('[data-add-label]');

    const updateVariant = () => {
      if (!optionSelects.length) return;
      const selected = optionSelects.map((select) => select.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) {
        addButton.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = variant.id;
      price.textContent = money(variant.price);
      if (variant.compare_at_price > variant.price) {
        comparePrice.hidden = false;
        comparePrice.textContent = money(variant.compare_at_price);
      } else {
        comparePrice.hidden = true;
      }
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'ADD TO CART' : 'Sold out';
    };
    optionSelects.forEach((select) => select.addEventListener('change', updateVariant));

    form.querySelectorAll('input[name="bundle"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        form.querySelectorAll('.bundle-card').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('.bundle-card').classList.add('is-selected');
        form.querySelector('[data-quantity]').value = radio.value;
      });
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (addButton.disabled) return;
      addButton.disabled = true;
      addLabel.textContent = 'ADDING…';
      const body = new FormData(form);
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body
        });
        if (!response.ok) throw new Error('Cart error');
        const cart = await fetch(`${window.Shopify.routes.root}cart.js`).then((result) => result.json());
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        const toast = document.querySelector('[data-cart-toast]');
        toast?.classList.add('is-visible');
        setTimeout(() => toast?.classList.remove('is-visible'), 3500);
        addLabel.textContent = 'ADDED';
      } catch (error) {
        addLabel.textContent = 'TRY AGAIN';
      } finally {
        setTimeout(() => {
          addButton.disabled = false;
          addLabel.textContent = 'ADD TO CART';
        }, 1200);
      }
    });
  });

  document.querySelectorAll('[data-clip-sound]').forEach((button) => {
    button.addEventListener('click', () => {
      const video = button.closest('.action-clip')?.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      button.classList.toggle('is-on', !video.muted);
      button.setAttribute('aria-label', video.muted ? 'Turn video sound on' : 'Mute video');
    });
  });
})();
